<mat-card class="p-0" *ngIf="case && case.documents && case.documents.length > 0">
  <div class="pt-16 ph-16 fx-row align-items-center justify-content-between">
    <div class="fx-column">
      <span class="text" *ngIf="readonly">{{ 'CASE.WRITE_EVIDENCES_DISABLED' | translate }}</span>
    </div>
    <div class="fx-row align-items-center justify-content-end">
      <button class="main-button" (click)="download()" *ngIf="case?.type === CaseType.RENEWAL_MAINTENANCE"
        [disabled]="selection.selected.length === 0" [class.disabled]="selection.selected.length === 0">
        {{ 'CASE.RENEWAL_MAINTENANCE.DOWNLOAD' | translate }} {{ selection.selected.length }} {{
        (("ENTITIES."+(case.type === CaseType.RENEWAL_MAINTENANCE ? 'DOCUMENT' : 'PROOF')+(selection.selected.length > 1
        ? 'S' : '')) | translate).toLowerCase()
        }}
      </button>
      <button class="danger-button ml-10" (click)="unlink()" *ngIf="selection.selected.length > 0">
        {{ 'CASE.UNLINK' | translate }} {{ selection.selected.length }} {{
        (("ENTITIES."+(case.type === CaseType.RENEWAL_MAINTENANCE ? 'DOCUMENT' : 'PROOF')+(selection.selected.length > 1
        ? 'S' : '')) | translate).toLowerCase()
        }}
      </button>
      <button class="main-button ml-10" [cdkMenuTriggerFor]="addMenu" [disabled]="readonly" [class.disabled]="readonly">
        {{ (case.type === CaseType.RENEWAL_MAINTENANCE ? 'CASE.RENEWAL_MAINTENANCE.ADD_DOCS' : 'CASE.ADD_PROOFS') |
        translate }}
      </button>
      <ng-template #addMenu>
        <mat-card class="menu-container p-0 elevation" style="max-width:180px;" cdkMenu>
          <div class="fx-column">
            <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
              (click)="openLinkDialog()" cdkMenuItem>
              <mat-icon class="dark mr-5" fontSet="material-icons-outlined">add_link</mat-icon>
              <span class="text fx-flex">{{ 'CASE.LINK_PROOFS' | translate }}</span>
            </div>
            <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
              (click)="openUploadDialog()" cdkMenuItem>
              <mat-icon class="dark mr-5" fontSet="material-icons-outlined">cloud_upload</mat-icon>
              <span class="text fx-flex">{{ 'CASE.UPLOAD_PROOFS' | translate }}</span>
            </div>
          </div>
        </mat-card>
      </ng-template>
    </div>
  </div>
  <app-documents-filter-drawer [count]="count" [(filters)]="filters" [case]="case"
    [relevantTerritories]="relevantTerritories" (filtersChange)="onFilterChange()">

    <mat-divider class="mv-16"></mat-divider>
    <app-documents-case [documents]="pager" [filteredDocuments]="filteredDocuments" (sort)="onSortChange($event)"
      (page)="handlePage($event)" [(selection)]="selection" [readonly]="readonly" [case]="case"
      [trademarkProductsServices]="trademarkProductsServices" [productsServices]="productsServices"
      #caseDocuments></app-documents-case>

  </app-documents-filter-drawer>
</mat-card>
<mat-card *ngIf="case && case.documents && case.documents.length == 0" class="placeholder">
  <div class="fx-flex-100 fx-row align-items-center justify-content-start">
    <div class="watermark-container">
      <img src="/assets/img/icon_lighter.svg" class="watermark" />
    </div>
    <div class="fx-row fx-wrap instructions-container">
      <span class="title dark fx-flex-100">{{(case.type === CaseType.RENEWAL_MAINTENANCE ?
        'CASE.RENEWAL_MAINTENANCE.NO_DOCS' : 'CASE.NO_LINKED_PROOFS') | translate}}</span>
      <span class="text dark fx-flex-100">{{(case.type === CaseType.RENEWAL_MAINTENANCE ?
        'CASE.RENEWAL_MAINTENANCE.NO_DOCS_TEXT' : 'CASE.NO_LINKED_PROOFS_TEXT') | translate:case.trademark}}</span>
      <div class="fx-row fx-flex-100 mt-10">
        <button class="main-button" (click)="openLinkDialog()">
          <div class="fx-row align-items-center justify-content-center">
            <mat-icon class="white mr-5" fontSet="material-icons-outlined">add_link</mat-icon>
            {{ (case.type === CaseType.RENEWAL_MAINTENANCE ? 'CASE.RENEWAL_MAINTENANCE.NO_DOCS_LINK' :
            'CASE.LINK_PROOFS') | translate}}
          </div>
        </button>
        <button class="main-button ml-10" (click)="openUploadDialog()">
          <div class="fx-row align-items-center justify-content-center">
            <mat-icon class="white mr-5" fontSet="material-icons-outlined">cloud_upload</mat-icon>
            {{ (case.type === CaseType.RENEWAL_MAINTENANCE ? 'CASE.RENEWAL_MAINTENANCE.NO_DOCS_UPLOAD' :
            'CASE.UPLOAD_PROOFS') | translate}}
          </div>
        </button>
      </div>
    </div>
  </div>
</mat-card>